'use strict';

define('cookieConsentConfiguration',['backbone', 'ActionTagConfig'],
  function CookieConsentConfiguration(Backbone, ATConfig) {
    var _ = Backbone._;
    var $ = Backbone.$;

    function getCookie(cookieName) {
      return document.cookie.split(';').some(function (c) {
        return c.trim().startsWith(cookieName + '=');
      });
    }

    function deleteCookie(cookieName, path) {
      if (getCookie(cookieName)) {
        var cookieString = cookieName + '=' + ((path) ? '; path=' + path : '') +
          '; domain=' + window.location.hostname +
          '; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        document.cookie = cookieString;
      }
    }

    function deletePerformanceCookies() {
      var cookies = document.cookie.split(';');

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf('=');
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        name = name.trim();
        if (name.startsWith('ai_')) {
          document.cookie = name + '=;path=/;domain=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
        }
        if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gtm') || name.startsWith('_gcl') || name.startsWith('__utm')) {
          deleteCookie(name, '/');
        }
      }
    }

    function deleteFunctionalCookies() {
      deleteCookie('ProfileDatabagId', '/');
      deleteCookie('FastActionDatabagId', '/');

      // On embeded forms/pages, cookies can be set from the vanity domain of the form/page
      // Delete these cookies using the following api calls
      var databagDomains = _.clone(ATConfig.DATABAG_SYNC_DOMAINS);

      databagDomains.forEach(function (domain) {
        // run async, nothing to do if it fails
        $.ajax({
          type: 'GET',
          url: domain + '/deleteDatabag/FastAction',
          crossDomain: true,
          xhrFields: { withCredentials: true }
        });

        $.ajax({
          type: 'GET',
          url: domain + '/deleteDatabag/Profile',
          crossDomain: true,
          xhrFields: { withCredentials: true }
        });
      });
    }

    var ConfigModel = Backbone.Model.extend({
      __name__: 'CookieConsentConfiguration',

      initialize: function () {
        this.set({
          'cookieConsentMode': ATConfig.DATABAG_COOKIE_CONSENT || false,
          'functionalAccepted': false,
          'performanceAccepted': false
        });

        _.bindAll(this, 'acceptPerformanceCookies', 'revokePerformanceCookies', 'acceptFunctionalCookies', 'revokeFunctionalCookies',
          'isCookieConsentEnabled');
      },

      isCookieConsentEnabled: function () {
        return this.get('cookieConsentMode');
      },

      areFunctionalCookiesAccepted: function() {
        return !this.get('cookieConsentMode') || this.get('functionalAccepted');
      },

      arePerformanceCookiesAccepted: function() {
        return !this.get('cookieConsentMode') || this.get('performanceAccepted');
      },

      acceptFunctionalCookies: function () {
        // Enable Profile Cookies
        this.set({
          'functionalAccepted': true
        });

        window.nvtag.data.profile.resetCheckedAllowList();

        // If any == "everybody", fetch profile
        if (ATConfig.DATABAG_SHARE_SETTING === 'everybody') {
          window.nvtag.data.profile.checkAllowListAndFetch();
        }

      },

      acceptPerformanceCookies: function () {
        this.set({
          'performanceAccepted': true
        });

        // Each of the following window functions are implemented in OA and called here
        if (window.cookieSettingsAcceptCookiesAi && !window.appInsights) {
          window.cookieSettingsAcceptCookiesAi();
        }
        else if (window.appInsights && window.appInsights.initialize && window.appInsights.getCookieMgr().isEnabled() === false) {
          //if the SDK is already loaded, the user revokes then accepts again:
          window.appInsights.getCookieMgr().setEnabled(true);
          window.appInsights.config.disableTelemetry = false;
        }

        if (window.cookieSettingsAcceptGoogleTagCookies) {
          window.cookieSettingsAcceptGoogleTagCookies();
        }

        if (window.cookieSettingsAcceptAnalyticsCookies) {
          window.cookieSettingsAcceptAnalyticsCookies();
        }
      },

      revokePerformanceCookies: function () {
        this.set({
          'performanceAccepted': false
        });

        if (window.appInsights) {
          window.appInsights.getCookieMgr().setEnabled(false);
          window.appInsights.config.disableTelemetry = true;
        }

        if (window.cookieSettingsRevokeAnalyticsCookies) {
          window.cookieSettingsRevokeAnalyticsCookies();
        }

        if (window.cookieSettingsRevokeGoogleTagCookies) {
          window.cookieSettingsRevokeGoogleTagCookies();
        }

        deletePerformanceCookies();
      },

      revokeFunctionalCookies: function () {
        // Delete Cookies
        deleteFunctionalCookies();

        // Clear databags
        window.nvtag.data.profile.clear();
        window.nvtag.data.fast.clear();

        // Race condition for hiding FA functionality between logout process and custom hide function
        window.user.logout();

        this.set({
          'functionalAccepted': false
        });
      }
    });

    var cookieConsentConfigModel = new ConfigModel();

    return cookieConsentConfigModel;
  });

